import { useEffect } from 'react';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRootElements,
} from '@backstage/plugin-techdocs-react';
import { discoveryApiRef, useApi } from '@backstage/core-plugin-api';
import { useLocation } from 'react-router-dom';
import { techdocsExtensionPlugin } from '../../plugin';

const getLinkHref = (baseUrl: string, ...segments: string[]) =>
  new URL(
    [baseUrl.replace(/\/+$/, '')]
      .concat(segments.map(s => s.replace(/^\/+|\/+$/g, '')))
      .join('/'),
  ).toString();

const TechDocsLinksAddon = () => {
  const images = useShadowRootElements<HTMLImageElement>([
    'img[data-techdocs-href]',
  ]);
  const links = useShadowRootElements<HTMLAnchorElement>([
    'a[data-techdocs-href]',
  ]);
  const techdocsBaseHrefPromise =
    useApi(discoveryApiRef).getBaseUrl('appfolio-techdocs');
  const { pathname } = useLocation();
  useEffect(() => {
    const updateTechDocsLinks = async () => {
      const techdocsBaseHref = await techdocsBaseHrefPromise;
      for (const link of links) {
        const techdocsHref = link.dataset.techdocsHref;
        if (typeof techdocsHref === 'undefined') {
          continue;
        }
        const replacement = document.createElement('a');
        for (const { name, value } of link.attributes) {
          replacement.setAttribute(name, value);
        }
        for (const childNode of link.childNodes) {
          replacement.appendChild(childNode);
        }
        replacement.classList.add('appfolio-techdocs-href');
        replacement.target = '_blank';
        replacement.href = getLinkHref(
          techdocsBaseHref,
          'static',
          pathname,
          techdocsHref,
        );
        link.replaceWith(replacement);
      }
      for (const image of images) {
        const techdocsHref = image.dataset.techdocsHref;
        if (typeof techdocsHref === 'undefined') {
          continue;
        }
        const link = document.createElement('a');
        link.classList.add('appfolio-techdocs-href');
        link.target = '_blank';
        link.href = getLinkHref(
          techdocsBaseHref,
          'static',
          pathname,
          techdocsHref,
        );
        image.parentNode?.insertBefore(link, image);
        link.appendChild(image);
        delete image.dataset.techdocsHref;
      }
    };
    updateTechDocsLinks();
  }, [images, links, techdocsBaseHrefPromise, pathname]);
  return null;
};

export const TechDocsLinks = techdocsExtensionPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsLinks',
    location: TechDocsAddonLocations.Content,
    component: TechDocsLinksAddon,
  }),
);
